import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { ImageList, ImageListItem } from '@mui/material';
import { createImageViewerButton, createImageViewer } from '../../helpers/imageViewerHelpers';
import { createStyledImageListItemBar } from '../../helpers';
import one from '../../Assets/SoloExhibition/1.jpg';
import two from '../../Assets/SoloExhibition/2.jpg';
import three from '../../Assets/SoloExhibition/3.jpg';
import four from '../../Assets/SoloExhibition/4.jpg';
import five from '../../Assets/SoloExhibition/5.jpg';
import seven from '../../Assets/SoloExhibition/7.jpg';
import eight from '../../Assets/SoloExhibition/8.jpg';
import nine from '../../Assets/SoloExhibition/9.jpg';
import ten from '../../Assets/SoloExhibition/10.jpg';
import thirteen from '../../Assets/SoloExhibition/13.jpg';
import fourteen from '../../Assets/SoloExhibition/14.jpg';
import fifteen from '../../Assets/SoloExhibition/15.jpg';

// Data structure for solo exhibition artwork
const soloExhibitionData = [
  { img: one, title: 'Solo Exhibition Artwork 1', author: 'Nikoletta' },
  { img: two, title: 'Solo Exhibition Artwork 2', author: 'Nikoletta' },
  { img: three, title: 'Solo Exhibition Artwork 3', author: 'Nikoletta' },
  { img: four, title: 'Solo Exhibition Artwork 4', author: 'Nikoletta' },
  { img: five, title: 'Solo Exhibition Artwork 5', author: 'Nikoletta' },
  { img: seven, title: 'Solo Exhibition Artwork 7', author: 'Nikoletta' },
  { img: eight, title: 'Solo Exhibition Artwork 8', author: 'Nikoletta' },
  { img: nine, title: 'Solo Exhibition Artwork 9', author: 'Nikoletta' },
  { img: ten, title: 'Solo Exhibition Artwork 10', author: 'Nikoletta' },
  { img: thirteen, title: 'Solo Exhibition Artwork 13', author: 'Nikoletta' },
  { img: fourteen, title: 'Solo Exhibition Artwork 14', author: 'Nikoletta' },
  { img: fifteen, title: 'Solo Exhibition Artwork 15', author: 'Nikoletta' },
];

function SoloExhibition() {
  // Image viewer state
  const [soloExhibitionImage, setSoloExhibitionImage] = React.useState(0);
  const [isSoloExhibitionViewerOpen, setIsSoloExhibitionViewerOpen] = React.useState(false);

  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">About intimacy Solo Exhibition </strong>
        </h1>
        <p style={{ color: 'black' }}>
          "Our home, the stories we have been told and the ones we may tell to
          others. In this exhibition I am trying to depict my own personal
          infinite effort to protect incidents or feelings that are likely to
          get lost and forgotten in time. Acrylic and mixed media paintings,
          together with some small-scale installations create an environment of
          reconciliation with all kinds of memories that shape us. The memories
          we achieved to embrace and the ones that we are still trying to accept
          as inextricable parts of ourselves." - Nikoletta Papakonstantinou
        </p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {soloExhibitionData.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setSoloExhibitionImage(index);
                setIsSoloExhibitionViewerOpen(true);
              },
              characterType: 'Solo Exhibition Artwork'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>

      {/* Image Viewer for full-screen display */}
      {createImageViewer({
        isOpen: isSoloExhibitionViewerOpen,
        images: soloExhibitionData.map(item => item.img),
        currentIndex: soloExhibitionImage,
        onClose: () => setIsSoloExhibitionViewerOpen(false),
      })}
    </Container>
  );
}

export default SoloExhibition;
